"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _Checkable = _interopRequireDefault(require("UIComponents/decorators/Checkable"));

var _Functions = require("UIComponents/core/Functions");

var _colors = require("HubStyleTokens/colors");

var _sizes = require("HubStyleTokens/sizes");

var _RatingTypes = require("../../constants/reviews/RatingTypes");

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  width: ", "px;\n  background-color: ", ";\n  border: 2px solid ", ";\n  border-radius: ", ";\n  height: ", "px;\n  margin: 1px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  width: ", "px;\n  background-color: ", ";\n  border-radius: ", ";\n  height: ", "px;\n  margin: 1px;\n  left: 0;\n  position: absolute;\n  overflow: hidden;\n  z-index: 1;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  line-height: 117%;\n  margin-right: 0 !important;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  line-height: 117%;\n  margin-right: 0 !important;\n  left: 0;\n  overflow: hidden;\n  position: absolute;\n  z-index: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ForegroundIcon = (0, _styledComponents.default)(_UIIcon.default).withConfig({
  displayName: "AbstractRatingRenderer__ForegroundIcon",
  componentId: "sc-1vnyk8s-0"
})(_templateObject(), _sizes.MERCURY_LAYER);
var BackgroundIcon = (0, _styledComponents.default)(_UIIcon.default).withConfig({
  displayName: "AbstractRatingRenderer__BackgroundIcon",
  componentId: "sc-1vnyk8s-1"
})(_templateObject2());

var ForegroundPill = _styledComponents.default.div.withConfig({
  displayName: "AbstractRatingRenderer__ForegroundPill",
  componentId: "sc-1vnyk8s-2"
})(_templateObject3(), function (props) {
  return props.width;
}, _colors.SLINKY, function (props) {
  return props.borderRadius;
}, function (props) {
  return props.height;
});

var BackgroundPill = _styledComponents.default.div.withConfig({
  displayName: "AbstractRatingRenderer__BackgroundPill",
  componentId: "sc-1vnyk8s-3"
})(_templateObject4(), function (props) {
  return props.width;
}, function (props) {
  return props.disabled ? _colors.GREAT_WHITE : '';
}, _colors.GREAT_WHITE, function (props) {
  return props.borderRadius;
}, function (props) {
  return props.height;
});

var AbstractRatingRenderer = function AbstractRatingRenderer(props) {
  var checked = props.checked,
      disabled = props.disabled,
      iconSize = props.iconSize,
      index = props.index,
      _onChange = props.onChange,
      onHoverChange = props.onHoverChange,
      onMouseEnter = props.onMouseEnter,
      onMouseLeave = props.onMouseLeave,
      percentFilled = props.percentFilled,
      type = props.type,
      rest = (0, _objectWithoutProperties2.default)(props, ["checked", "disabled", "iconSize", "index", "onChange", "onHoverChange", "onMouseEnter", "onMouseLeave", "percentFilled", "type"]);
  var hasPercentage = percentFilled != null;
  var backgroundIconUnchecked = !checked || hasPercentage;
  var foregroundIcon = (0, _react.useMemo)(function () {
    return _react.default.createElement(ForegroundIcon, {
      color: _RatingTypes.RatingTypesTemplate[type].checkedColor,
      name: _RatingTypes.RatingTypesTemplate[type].checkedIcon,
      role: "presentation",
      size: iconSize,
      style: {
        width: percentFilled / 100 + "em"
      }
    });
  }, [iconSize, percentFilled, type]);
  var backgroundIcon = (0, _react.useMemo)(function () {
    return _react.default.createElement(BackgroundIcon, {
      color: backgroundIconUnchecked ? _RatingTypes.RatingTypesTemplate[type].uncheckedColor : _RatingTypes.RatingTypesTemplate[type].checkedColor,
      name: backgroundIconUnchecked ? _RatingTypes.RatingTypesTemplate[type].uncheckedIcon : _RatingTypes.RatingTypesTemplate[type].checkedIcon,
      size: iconSize
    });
  }, [backgroundIconUnchecked, type, iconSize]);
  var borderRadius = index === 1 ? '8px 0 0 8px' : index === 5 ? '0 8px 8px 0' : 0;
  var pillHeight = disabled ? 8 : 15;
  var pillWidth = disabled ? 20 : 30;
  var foregroundPill = (0, _react.useMemo)(function () {
    return _react.default.createElement(ForegroundPill, {
      width: percentFilled * pillWidth / 100,
      borderRadius: !(percentFilled < 100 && index === 5) && borderRadius,
      height: pillHeight
    });
  }, [borderRadius, percentFilled, pillHeight, pillWidth, index]);
  var backgroundPill = (0, _react.useMemo)(function () {
    return _react.default.createElement(BackgroundPill, {
      width: pillWidth,
      borderRadius: borderRadius,
      height: pillHeight,
      disabled: disabled
    });
  }, [borderRadius, pillHeight, pillWidth, disabled]);
  var foreground = hasPercentage && type === _RatingTypes.PILL_RATING ? foregroundPill : foregroundIcon;
  var background = type === _RatingTypes.PILL_RATING ? backgroundPill : backgroundIcon;
  var onMouseEnterWithHover = (0, _react.useCallback)(function (evt) {
    (0, _Functions.callIfPossible)(onMouseEnter, evt);
    (0, _Functions.callIfPossible)(onHoverChange, index);
  }, [onMouseEnter, onHoverChange, index]);
  var onMouseLeaveWithHover = (0, _react.useCallback)(function (evt) {
    (0, _Functions.callIfPossible)(onMouseLeave, evt);
    (0, _Functions.callIfPossible)(onHoverChange, null);
  }, [onMouseLeave, onHoverChange]);
  return _react.default.createElement("label", (0, _extends2.default)({}, rest, {
    onMouseEnter: onMouseEnterWithHover,
    onMouseLeave: onMouseLeaveWithHover,
    style: {
      position: 'relative',
      cursor: disabled ? 'default' : 'pointer',
      display: 'inline-flex'
    }
  }), _react.default.createElement("input", {
    className: "sr-only",
    checked: checked,
    type: "checkbox",
    onChange: function onChange(evt) {
      _onChange(evt);
    }
  }), background, foreground);
};

AbstractRatingRenderer.propTypes = {
  checked: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  iconSize: _propTypes.default.string,
  index: _propTypes.default.number.isRequired,
  onChange: _propTypes.default.func,
  onHoverChange: _propTypes.default.func,
  onMouseEnter: _propTypes.default.func,
  onMouseLeave: _propTypes.default.func,
  percentFilled: _propTypes.default.number,
  type: _propTypes.default.oneOf(Object.keys(_RatingTypes.RatingTypesTemplate))
};
AbstractRatingRenderer.defaultProps = {
  iconSize: 'xs',
  type: _RatingTypes.STAR_RATING_FILLED
};

var _default = (0, _Checkable.default)(AbstractRatingRenderer);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/components/reviews/AbstractRatingRenderer.js
// module id = 714
// module chunks = 209 210 211 212